/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAlbumCollectionsIdQueryResponse, GetApiAlbumCollectionsIdPathParams, GetApiAlbumCollectionsId400, GetApiAlbumCollectionsId401, GetApiAlbumCollectionsId403, GetApiAlbumCollectionsId404, GetApiAlbumCollectionsId500 } from "../../types/GetApiAlbumCollectionsId.ts";
import { getApiAlbumCollectionsIdQueryResponseSchema } from "../../zod/AlbumCollectionSchemas/getApiAlbumCollectionsIdSchema.ts";

function getGetApiAlbumCollectionsIdUrl({ id }: { id: GetApiAlbumCollectionsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/album-collections/${id}` as const }  
  return res
}

/**
 * @summary Получение выпуска
 * {@link /api/album-collections/:Id}
 */
export async function getApiAlbumCollectionsId({ id }: { id: GetApiAlbumCollectionsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAlbumCollectionsIdQueryResponse, ResponseErrorConfig<GetApiAlbumCollectionsId400 | GetApiAlbumCollectionsId401 | GetApiAlbumCollectionsId403 | GetApiAlbumCollectionsId404 | GetApiAlbumCollectionsId500>, unknown>({ method : "GET", url : getGetApiAlbumCollectionsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiAlbumCollectionsIdQueryResponseSchema.parse(res.data)
}